import { ContainerModule } from 'inversify';
import { InteractionStateService, InteractionStateServiceSymbol } from './interaction-state-service'
import { InteractionStateMachine, InteractionStateMachineSymbol } from './state-machine/interaction-state-machine'
import { InteractionStateChooserFactory, InteractionStateChooserFactorySymbol,
         InteractionStateChooserPlugin, InteractionStateChooserPluginSymbol } from '../api';

export const interactionServiceModule = new ContainerModule((bind) => {
  bind(InteractionStateServiceSymbol).to(InteractionStateService).inSingletonScope();
  bind(InteractionStateMachineSymbol).to(InteractionStateMachine)

  bind<InteractionStateChooserFactory<unknown>>(InteractionStateChooserFactorySymbol).toFactory<InteractionStateChooserPlugin<unknown>>((context) => {

    const defaultChooser = new DefaultInteractionStateChooser()

    return (type: string) => {

      if (!context.container.isBoundNamed(InteractionStateChooserPluginSymbol, type)) {
        return defaultChooser
      }

      return context.container.getNamed<InteractionStateChooserPlugin<unknown>>(
        InteractionStateChooserPluginSymbol, type);
    }
  })
});

class DefaultInteractionStateChooser implements InteractionStateChooserPlugin<unknown> {

  choose() {
    return 'use-local' as 'use-local'
  }
}
